import AdminView from './components/admin/RegisterManagement.vue';
import MainRegistersPage from './views/index.vue';
import RegistersRegisterView from './views/RegisterTable.vue';
import permissions from '@Share/config/permissions';

export default [
  // Admin routes
  {
    path: '/manage-registers',
    name: 'RegistersAdmin',
    component: AdminView,
    meta: {
      requiresAuth: true,
      layout: 'accountLayout',
      title: 'Register Management',
      permissions: [permissions.Registers.View],
    },
  },

  {
    path: '/:id/registers/:registerId',
    component: MainRegistersPage,
    meta: {
      requiresAuth: true,
      facilityScope: true,
      layout: 'viewer-layout',
    },
    children: [
      {
        path: '',
        name: 'RegisterView',
        component: RegistersRegisterView,
        meta: {
          requiresAuth: true,
          title: 'Register Details',
          layout: 'viewer-layout',
        },
      },
    ],
  },
  {
    path: '/:id/sync-activity',
    name: 'SyncActivity',
    component: () => import('./views/SyncActivityView.vue'),
    meta: {
      requiresAuth: true,
      facilityScope: true,
      layout: 'viewer-layout',
      title: 'Sync Activity',
      permissions: [permissions.Admin.Access],
    },
  },
];
